<template>
  <div class="product-card h-100 w-100 my-4 d-flex flex-column">
    <div class="produit-image bg-white round-10">
      <i
        class="favorite fa p-2"
        :class="{
          'fa-heart': product.has_favorite,
          'fa-heart-o': !product.has_favorite,
        }"
        @click="ToggleFavorite(product)"
      ></i>
      <img
        :src="product.images?.length > 0 ? product.images[0].path : ProductImgDefault"
        :alt="product.name"
        class="prod-img"
        @click.prevent="goToProduct(product)"
      />
    </div>
    <div class="product-info px-0">
      <span class="gamme mt-2">{{ product.gamme_supplyvet ?? "" }}</span>
      <h3 class="title" @click.prevent="goToProduct(product)">
        {{ product.name }}
      </h3>
      <div class="desc">
        <label class="col col-lg-8">{{
          product.description != null ? truncateHtmlContent(product.description) : ""
        }}</label>
        <div v-if="product.variant && product.variant.currentChannelPricings" class="price-section my-auto col col-lg-4 px-0 mx-0">

          <!-- Original Price (only show if there's a discount) -->
          <span
            v-if="isClient ? product.variant.price_original_ttc > product.variant.price_ttc : product.variant.price_original_ht > product.variant.price_ht"
            class="old-price ms-2"
          >
            {{ formatPrice(isClient ? product.variant.price_original_ttc  :  product.variant.price_original_ht ) }} 
            {{ isClient ? $t("product_card.price_ttc") : $t("product_card.price_ht") }}
          </span>
          <!-- Current Price -->
          <span class="price">
            {{ formatPrice(isClient ? product.variant.price_ttc  : product.variant.price_ht ) }} 
            {{ isClient ? $t("product_card.price_ttc") : $t("product_card.price_ht") }}
          </span>
          
          
        </div>
      </div>
      <button class="btn text-white product-more w-100 mt-2" @click="goToProduct(product)">
        {{ $t("product_card.more") }}
      </button>
    </div>
  </div>
</template>

<script>
  import ProductImgDefault from "@/assets/images/product_default.png";
  import { useProductsStore } from "@/stores/productsStore";
import { useRegisterStore } from '@/stores/register';

  export default {
    data() {
      return {
        ProductImgDefault,
        productsStore: null,
      };
    },
    props: {
      product: {
        type: Object,
        required: true,
      },
    },
    created() {
      this.productsStore = useProductsStore();
      this.registerStore = useRegisterStore();
    },
     computed: {
      isClient() {
        return this.registerStore.user?.role === "client";
      },
    },
    methods: {
      ToggleFavorite(prod) {
        prod.has_favorite = !prod.has_favorite;
        if (prod.has_favorite) {
          this.productsStore.AddFavoriteProduct(prod);
        } else {
          this.productsStore.RemoveFavoriteProduct(prod);
        }
      },
      truncateHtmlContent(html) {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;

        const plainText = tempDiv.textContent || tempDiv.innerText || "";
        return plainText.length > 40 ? plainText.slice(0, 40) + "..." : plainText;
      },
      goToProduct(prod) {
        if (prod.with_details_page === false) {
        return; // Do not navigate if with_details_page is false
      }
        var slug = prod.slug;
        this.$router.push({ name: "ProductDetail", params: { slug } });
      },

      formatPrice(value) {
        if (value == null || isNaN(value)) return '0,00';
        const num = Number(value) / 100;
        return num.toFixed(2).replace('.', ',');
      }
    },
   
  };
</script>
<style scoped>
  .product-card {
    display: flex;
    flex-direction: column;
    height: 100%;
    transition: transform 0.2s;
    margin-right: 1rem;
    transform: scale(0.95);
    transform-origin:top;
  }



  .produit-image {
    padding: 15px;
    border: 1px solid #fdfdfd;
    border-radius: 10px;
    background: #fff;
    text-align: center;
    cursor: pointer;
    aspect-ratio: 1 / 1; 
  }

  .produit-image img {
    max-width: 85%;
    height: 100% !important;
    object-fit: contain;
    aspect-ratio: 1 / 1;  }
  .product-info {
    flex: 1;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  .product-info .title {
    font-size: 20px;
    font-weight: bold;
    color: #1e347d;
    height: 20%;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    cursor: pointer;
  }
  .product-card .gamme {
    font-size: 16px;
    font-weight: 300;
    font-style: normal;
    text-align: left;
    color: #1e347d;
    min-height: 14px;
  }
  .product-card .title {
    font-size: 20px;
    font-weight: bold;
    font-style: normal;
    text-align: left;
    color: #1e347d;
    height: min-content;
  }
  .product-card .desc {
    text-align: left;
    display: flex;
  }
  .product-card .desc label {
    font-size: 14px;
  }
  .product-card .favorite {
    float: right;
    cursor: pointer;
  }

  .price {
    font-weight: bold;
    font-size: 20px !important;
    color: #1e347d;
    text-align: right;
    span {
      font-size: 14px;
    }
  }
  .product-more {
    background-color: #ec621a !important;
    border-radius: 76px;
    font-size: 15px;
    text-align: center;
  }
  @media (min-width: 768px) and (max-width: 1367px) {
    .product-card {
      .title {
        font-size: 14px;
      }
      .desc {
        label {
          font-size: 12px;
        }
      }
    }
    .price {
      font-weight: 600;
      font-size: 12px;
    }
  }
  @media (max-width: 768px) {
    .product-card {
      .title {
        font-size: 13px;
      }
      .desc {
        label {
          font-size: 12px;
        }
      }
    }
    .price {
      font-weight: 600;
      font-size: 12px;
    }
  }


.old-price {
  text-decoration: line-through;
  color: #999;
  font-size: 0.9em;
}

.price-section {
display: flex;
flex-direction: column;
align-items: center;
}

</style>
